import { render } from "./LanguageForm.vue?vue&type=template&id=324093d8&ts=true"
import script from "./LanguageForm.vue?vue&type=script&lang=ts"
export * from "./LanguageForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__